module.exports = __webpack_public_path__ + "img/shopping_cart.f5da511b.svg";